var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.CreateCompanyDialog,{ref:"createCompanyDialog"}),(_setup.isAuthorized)?_c(_setup.ArticleCreateDialog,{ref:"articleCreateDialog"}):_vm._e(),_c(_setup.WorkspaceCreateDialog),_c(_setup.BotSettingsDialog,{ref:"botSettingsDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }